import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CompanyCardList from "./CompanyCardList";
import { useEffect } from "react";
import { getCandidatesByUserId } from "../Store/Thunk";
import { SetSelectedPageWithoutUrl } from "../../../AppMenu/Store";

const UserProfile = ({}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedPage = useSelector((state) => state.appMenu.selectedPage);
  const userId = useSelector((state) => state.auth.user.userId);
  const candidateInfo = useSelector((state) => state.userProfile.candidateInfo);

  useEffect(() => {
    dispatch(getCandidatesByUserId({ UserId: userId }));
  }, []);
  useEffect(() => {
    if (selectedPage.url !== "/myProfile") dispatch(SetSelectedPageWithoutUrl({ url: "/myProfile" }));
  }, [selectedPage]);

  return (
    <Row className={"mx-0"}>
      <Col>
        <CompanyCardList></CompanyCardList>
      </Col>
    </Row>
  );
};

export default UserProfile;
